export const parseSearchTerm = (
  search: string,
): {
  type: 'exact' | 'like';
  value: string;
} => {
  const trimmedInput = search.trim();

  if (trimmedInput.startsWith('"') && trimmedInput.endsWith('"')) {
    const exactValue = trimmedInput.substring(1, trimmedInput.length - 1);

    return {
      type: 'exact',
      value: exactValue,
    };
  } else {
    return {
      type: 'like',
      value: trimmedInput,
    };
  }
};
